import { Component, OnInit } from '@angular/core';
import { AuthorizeService } from 'src/app/services/authorize/authorize.service';


@Component({
  selector: 'app-newDashboard',
  templateUrl: './newDashboard.component.html',
})
export class NewDashboardComponent implements OnInit {

  constructor(
    private _authorizeService: AuthorizeService) {

  }

  ngOnInit() {

  }

}
